export const environment = {
  apiKey: '',
  apiUrl: 'https://api.upcareeraicv.com/',
    apiCvPath: 'https://api.upcareeraicv.com',
  apiImagePath: 'https://api.upcareeraicv.com/',

  envName: 'live', // Environment name
};